<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card class="mb-4">
          <div class="vx-row">
            <div class="vx-col w-full flex justify-between items-center">
              <filter-ground
                @get-data="filterRes"
                ref="filter"
                :filter_status_id="
                  filterModerationData.status && filterModerationData.status.id
                "
                :ecology_type="filterModerationData.ecology_type"
              ></filter-ground>
              <div class="w-1/6">
                <vs-input
                  class="w-full"
                  v-model="filterModerationData.search"
                  @input="getEmissionsWithFilter('search')"
                  :placeholder="$t('system.search')"
                ></vs-input>
              </div>
            </div>
          </div>
        </vx-card>
        <div class="flex gap-3" v-if="checkButtonPermission('csak_d_card_earth_moder_statistic')">
          <statistics-card-line
            hideChart
            icon="DatabaseIcon"
            :statisticTitle="$t('All data')"
            color="success"
            :statistic="cardInformation.all_count || 0"
          />
          <statistics-card-line
            hideChart
            icon="ArrowDownLeftIcon"
            :statisticTitle="$t('New')"
            color="primary"
            :statistic="cardInformation.new_count || 0"
          />
          <statistics-card-line
            hideChart
            icon="EditIcon"
            :statisticTitle="$t('Edited')"
            :statistic="cardInformation.waiting_count ||0"
            color="warning"
          />
          <statistics-card-line
            hideChart
            icon="CheckCircleIcon"
            :statisticTitle="$t('Accepted')"
            color="success"
            :statistic="cardInformation.success_count ||0"
          />

          <statistics-card-line
            hideChart
            icon="XCircleIcon"
            :statistic="cardInformation.reject_count || 0"
            :statisticTitle="$t('Canceled')"
            color="danger"
          />
          <statistics-card-line
            hideChart
            icon="ListIcon"
            :statistic="cardInformation.company_object_count || 0"
            :statisticTitle="$t('By objects')"
            color="success"
          />
          <statistics-card-line
            hideChart
            icon="ListIcon"
            :statistic="cardInformation.source_count || 0"
            :statisticTitle="$t('By sources')"
            color="success"
          />
        </div>
        <vx-card class="mt-4">
          <moderation-table
            :resData="emissionsData"
            @update="getEmissionsWithFilter"

          >
            <template #export-csv>
              <vs-button
                id="export-to-csv"
                v-if="checkButtonPermission('csak_d_card_earth_moder_export_exel')"
                @click="exportToCSV"
                color="success"
                :disabled="exportPending"
                type="filled"
                class="mr-4"
                :class="exportPending ? 'text-success' : ''"
              >
                {{ $t('Export xls') }}
              </vs-button>
            </template>
          </moderation-table>

          <div class="vx-row w-full mt-2">
            <div class="vx-col w-1/2 flex">
              <vs-button
                size="small"
                v-for="(page_size, index) in pageSizeVariant"
                :key="index"
                @click="
                  filterModerationData.page_size = page_size;
                  filterModerationData.page = 1;
                  getEmissionsWithFilter();
                "
                :color="
                  filterModerationData.page_size == page_size
                    ? 'primary'
                    : 'gray'
                "
                class="
                  p-0
                  w-10
                  h-10
                  rounded-full
                  flex
                  justify-center
                  items-center
                  mr-1
                "
              >
                {{ page_size }}
              </vs-button>
            </div>
            <div class="vx-col w-1/2 flex">
              <vs-pagination
                :max="totalData < 10 ? totalData : 10"
                :total="totalData"
                v-model="filterModerationData.page"
                @change="getEmissionsWithFilter"
              ></vs-pagination>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import moderationTable from "./moderation/moderationTable.vue";

import filterGround from "./sidebarFilter/filter";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
  data: () => ({
    exportPending: false,
    pageSizeVariant: [10, 50, 100, 500, 1000],
    // subsectionSelected: {
    //   id: 1,
    //   label: "Общесанитарные показатели",
    //   selected: "sanitary",
    // },
    emissionsData: [],
    cardInformation: {},
    totalData: 0, // максимальное количество страниц
    filterCurrent: {}, // сurrent filter
    filterModerationData: {
      page_size: 10,
      page: 1,
      ecology_type: {
        color: "danger",
        display_name: "Почва",
        id: 2,
        name: "soil",
      },
      status: {id: 3, status_name: "Новый", status_color: "primary"},
      // region_id: null,
      /* {
        // переменная для типа выброса
        color: "success",
        display_name: "Воздух",
        id: 1,
        name: "air",
      },
      {
        color: "danger",
        display_name: "Почва",
        id: 2,
        name: "soil",
      },
      {
        color: "primary",
        display_name: "Вода",
        id: 3,
        name: "water",
      }, */
      region_id: null,
      search: "",
    },
    intTime: null, // переменная для timeout против dDos
  }),
  created() {
    this.$store
      .dispatch("emissions/fetchCart", {ecology_type_id: 2}).then((res) => {
      this.cardInformation = res.data
    })
    if (this.$route.query && this.$route.query.page) {
      this.filterModerationData.page = this.$route.query.page;
    }
  },
  methods: {
    getEmissionsWithFilter(val) {
      let filterObj = {};
      let {
        page_size,
        page,
        status,
        type_dail,
        region_id,
        district,
        start_date,
        end_date,
        search,
        group,
        object,
        normative_is_active,
        values,
        component,
      } = this.filterModerationData;
      if (val === 'search') {
        if (page) filterObj.page = 1
      } else {
        if (page) filterObj.page = page
      }
      if (page_size) filterObj.page_size = page_size;
      if (search) filterObj.search = search;
      if (region_id && region_id.length > 0) {
        filterObj.region_id = region_id
      }
      if (district && district.length > 0) {
        filterObj.district = district
      }
      if (status && status.length > 0) {
        filterObj.status = status
      }
      filterObj.type_dail = type_dail
      if (start_date) filterObj.start_date = start_date;
      if (end_date) filterObj.end_date = end_date;
      if (object && object.length > 0) {
        filterObj.object = object
      }
      if (group && group.length > 0) {
        filterObj.group = group
      }
      if (normative_is_active && normative_is_active.length > 0) {
        filterObj.normative_is_active = normative_is_active
      }
      if (values && values.length > 0) {
        filterObj.status_normative = values
      }
      if (component && component.length > 0) {
        filterObj.component = component
      }
      // filterObj.status = 3
      filterObj.ecology_type_id = 2
      filterObj.is_moderator = 'True'
      clearTimeout(this.intTime);

      // Закидываю timeout в переменную чтобы потом удалить
      this.intTime = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          text: this.$t('loading_text')
        });
        this.$store
          .dispatch(
            "emissions/fetchDailyPollutionEmissionsWithFilters",
            filterObj
          )
          .then((res) => {
            this.emissionsData = res.data.data;
            this.totalData = Math.ceil(
              res.data.total / this.filterModerationData.page_size
            );
            this.filterCurrent = Object.assign({}, this.filterModerationData);
            this.$vs.loading.close();
          })
          .catch((err) => this.$vs.loading.close());
      }, 800);
    },

    filterRes(value) {
      this.filterModerationData = {
        page: 1,
        page_size: this.filterModerationData.page_size,
        ...value,
      };
      this.getEmissionsWithFilter();
    },
    async exportToCSV() {
      this.exportPending = true;
      this.$vs.loading({
        container: "#export-to-csv",
        scale: 0.6,
        color: "success",
      });
      let filterObj = {};
      let {
        page_size,
        page,
        status,
        type_dail,
        region,
        district,
        start_date,
        end_date,
        search,
        group,
        object,
        normative_is_active,
        values,
        component,
      } = this.filterModerationData;
      if (page_size) filterObj.page_size = page_size;
      if (page) filterObj.page = page
      if (search) filterObj.search = search;
      if (region && region.length > 0) {
        filterObj.region = region
      }
      if (district && district.length > 0) {
        filterObj.district = district
      }
      if (status && status.length > 0) {
        filterObj.status = status
      }
      filterObj.type_dail = type_dail
      if (start_date) filterObj.start_date = start_date;
      if (end_date) filterObj.end_date = end_date;
      if (object && object.length > 0) {
        filterObj.object = object
      }
      if (group && group.length > 0) {
        filterObj.group = group
      }
      if (normative_is_active && normative_is_active.length > 0) {
        filterObj.normative_is_active = normative_is_active
      }
      if (values && values.length > 0) {
        filterObj.status_normative = values
      }
      if (component && component.length > 0) {
        filterObj.component = component
      }
      filterObj.ecology_type_id = 2
      filterObj.is_moderator = 'True'
      await this.$store
        .dispatch("emissions/fetchDailyPollutionEmissionsWithFilters", {
          ...filterObj,
          excel: true,
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Факты выбросов.xls`);
          document.body.appendChild(link);
          link.click();
          this.exportPending = false;
          this.$vs.loading.close("#export-to-csv > .con-vs-loading");
        })
        .catch(() => {
          this.exportPending = false;
          this.$vs.loading.close("#export-to-csv > .con-vs-loading");
        });
    },
  },
  components: {
    StatisticsCardLine,
    moderationTable,
    filterGround,
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.filter.$data.sidebarState = false;
    setTimeout(() => {
      next();
    }, 10);
  },
};
</script>
